import {Component, OnInit, signal} from '@angular/core';
import {CodaltComponent} from '../codalt.component';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {Functionality} from '../classes/auth/functionality';
import {Feature} from '../classes/auth/feature.class';
import {Role} from '../classes/auth/role.class';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {RoleHasFunctionalityPipe} from './role-has-functionality.pipe';
import {FunctionalityHasFeaturePipe} from './functionality-has-feature.pipe';

@Component({
    selector: 'app-rights-management',
    templateUrl: './rights-management.component.html',
    styleUrl: './rights-management.component.scss',
    imports: [
        MatTabGroup,
        MatTab,
        RoleHasFunctionalityPipe,
        FunctionalityHasFeaturePipe
    ]
})
export class RightsManagementComponent extends CodaltComponent implements OnInit {

    disabled = false;

    readonly roles = signal<Role[]>(null);
    readonly functionalities = signal<Functionality[]>(null);
    readonly features = signal<Feature[]>(null);

    search: string;

    constructor(private authorisationService: AuthorisationService) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.authorisationService.getRoles().subscribe(roles => {
            this.roles.set(roles);
        }));
        this.subscriptions.add(this.authorisationService.getFunctionalities().subscribe(functionalities => {
            this.functionalities.set(functionalities);
        }));
        this.subscriptions.add(this.authorisationService.getFeatures().subscribe(features => {
            this.features.set(features);
        }));
    }

    checkFunctionality(event, functionality: Functionality, role: Role) {
        if (this.environment.production) {
            return;
        }

        if ((event.target as HTMLInputElement).checked) {
            this.subscriptions.add(this.authorisationService.addFunctionalityToRole(role.key, functionality.key).subscribe());
        } else {
            this.subscriptions.add(this.authorisationService.removeFunctionalityFromRole(role.key, functionality.key).subscribe());
        }
    }

    checkFeature(event, functionality: Functionality, feature: Feature) {
        if (this.environment.production) {
            return;
        }

        if ((event.target as HTMLInputElement).checked) {
            this.subscriptions.add(this.authorisationService.addFeatureToFunctionality(functionality.key, feature.key).subscribe());
        } else {
            this.subscriptions.add(this.authorisationService.removeFeatureFromFunctionality(functionality.key, feature.key).subscribe());
        }
    }

}
